export const ADMISSION_TIERS = ['ivy', 'oxbridge', 'tier1_uk', 'tier1_eu'] as const;
export type AdmissionTier = typeof ADMISSION_TIERS[number];

export const ADMISSION_TIER_LABELS: Record<AdmissionTier, string> = {
  ivy: 'Ivy League',
  oxbridge: 'Oxbridge',
  tier1_uk: 'Tier I UK',
  tier1_eu: 'Tier I EU',
};

export const IVY_LEAGUE_UNIVERSITIES = [
  'Harvard University',
  'Yale University',
  'Princeton University',
  'Columbia University',
  'University of Pennsylvania',
  'Brown University',
  'Dartmouth College',
  'Cornell University',
];

export const OXBRIDGE_UNIVERSITIES = ['University of Oxford', 'University of Cambridge'];

export const TIER_ONE_UK_UNIVERSITIES = [
  'University of Oxford',
  'University of Cambridge',
  'Imperial College London',
  'London School of Economics',
  'UCL',
  'University College London',
  'University of Edinburgh',
  "King's College London",
  'University of Manchester',
  'University of Warwick',
  'University of Bristol',
  'Durham University',
  'University of St Andrews',
  'University of Glasgow',
];

export const TIER_ONE_EU_UNIVERSITIES = [
  'Bocconi University',
  'ETH Zurich',
  'EPFL',
  'Sciences Po',
  'HEC Paris',
  'ESSEC',
  'ESCP',
  'École Polytechnique',
  'Université PSL',
  'Sorbonne',
  'IE University',
  'Esade',
  'Delft University of Technology',
  'University of Amsterdam',
  'Leiden University',
  'Erasmus University Rotterdam',
  'Utrecht University',
  'KU Leuven',
  'LMU Munich',
  'Technical University of Munich',
  'Heidelberg University',
  'Trinity College Dublin',
  'University of Copenhagen',
  'Lund University',
  'Uppsala University',
  'University of Vienna',
  'Politecnico di Milano',
];

export const EU_COUNTRIES = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'Norway',
  'Iceland',
  'Liechtenstein',
];

export const NETHERLANDS_COUNTRY = 'Netherlands';
export const TOP_100_RANK_LIMIT = 100;

export const DEFAULT_ADMISSION_TIER_LISTS: Record<AdmissionTier, string[]> = {
  ivy: IVY_LEAGUE_UNIVERSITIES,
  oxbridge: OXBRIDGE_UNIVERSITIES,
  tier1_uk: TIER_ONE_UK_UNIVERSITIES,
  tier1_eu: TIER_ONE_EU_UNIVERSITIES,
};
